import React from 'react'

import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'

import { createMuiTheme, ThemeProvider, withStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import Header from './components/Header'
import Content from './components/Content'
import Footer from './components/Footer'
import Underwater from './components/Underwater'


// Force CSSPlugin to not get dropped during build
gsap.registerPlugin(CSSPlugin)


const theme = createMuiTheme({
  shape: {
    borderRadius: 18,
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h3: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 600, letterSpacing: '-0.01em' },
    h4: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 600, letterSpacing: '-0.01em' },
    h5: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 500 },
  },
  overrides: {
    // Translucent cards over the ocean gradient. No backdrop-filter: giant
    // blurred surfaces over the animated parallax SVG cause repaint flicker.
    MuiPaper: {
      root: {
        backgroundColor: 'rgba(255,255,255,0.9)',
        border: '1px solid rgba(255,255,255,0.35)',
      },
      rounded: {
        borderRadius: 22,
      },
      elevation3: {
        boxShadow: '0 30px 70px -24px rgba(0,15,35,0.55), 0 6px 20px -6px rgba(0,15,35,0.25)',
      },
      outlined: {
        backgroundColor: 'rgba(255,255,255,0.6)',
      },
    },
    MuiCard: {
      root: {
        transition: 'transform .25s ease, box-shadow .25s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 22px 44px -18px rgba(0,15,35,0.5)',
        },
      },
    },
  },
})


const styles = () => ({
  '@global': {
    body: {
      color: '#111',
      background: 'linear-gradient(#005380, #002133)',
    },
  },
  wrapper: {
    position: 'relative',
  },
})


class App extends React.Component {

  render() {
    const {classes} = this.props
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={classes.wrapper}>
          <Header />
          <Underwater />
          <Content />
          <Footer />
        </div>
      </ThemeProvider>
    )
  }
}


export default withStyles(styles)(App)
